import React, { useEffect, useState } from 'react';
import '../styles/Home.css';

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="svg-icon">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="svg-icon">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="svg-icon">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
  </svg>
);

const Home = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Images pour le carrousel
  const carouselImages = [
    {
      src: '/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.28.jpeg',
      alt: 'Étudiants burkinabés au Sénégal'
    },
    {
      src: '/images/rentree_2026/WhatsApp Image 2026-10-09 at 18.52.28 (1).jpeg',
      alt: 'Étudiants à la rentrée syndicale 2026'
    },
    {
      src: '/images/redaction_administrative/redaction.jpg',
      alt: 'Formation en rédaction administrative'
    },
    {
      src: '/images/rentree_syndicale_2024/rentree.jpg',
      alt: 'Rentrée syndicale de l’ASB'
    },
    {
      src: '/images/carrefour_metier_2025/metier.jpg',
      alt: 'Carrefour des métiers'
    },
    {
      src: '/images/passation_2025/passation.jpg',
      alt: 'Passation du bureau de l’ASB'
    }
  ];



  // Carrousel automatique
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % carouselImages.length
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [carouselImages.length]);

  const highlightCards = [
    {
      id: 'events',
      title: 'Activités',
      description: 'Découvrez nos activités culturelles, académiques et de networking.',
      link: '/activites',
      color: 'red',
      badge: 'Évènements',
      icon: <CalendarIcon />
    },
    {
      id: 'bureau',
      title: 'Notre Bureau',
      description: 'Rencontrez les membres dévoués qui dirigent notre association.',
      link: '/bureau',
      color: 'black',
      badge: 'Équipe',
      icon: <UsersIcon />
    },
    {
      id: 'join',
      title: 'Rejoignez-nous',
      description: 'Devenez membre et participez à notre communauté dynamique.',
      link: '/contact',
      color: 'red',
      badge: 'Adhésion',
      icon: <StarIcon />
    }
  ];

  const stats = [
    { number: '500+', label: 'Membres actifs' },
    { number: '65+', label: 'Années d\'existence' },
    { number: '100%', label: 'Engagement' }
  ];

  const handleJoinClick = () => {
    window.location.href = '/contact';
  };

  return (
    <div className="home">
      {/* Section Hero avec carrousel */}
      <section className="hero">
        <div className="hero-background">
          <div className="image-carousel">
            {carouselImages.map((image, index) => (
              <div
                key={index}
                className={`carousel-slide ${index === currentImageIndex ? 'active' : ''}`}
                style={{ backgroundImage: `url(${image.src})` }}
              >
                <div className="carousel-overlay"></div>
              </div>
            ))}
          </div>

          <div className="floating-elements">
            <div className="float-element float-1"></div>
            <div className="float-element float-2"></div>
            <div className="float-element float-3"></div>
          </div>
        </div>

        <div className="hero-content" data-animate id="hero">
          <h1>Association des Scolaires Burkinabés à Dakar</h1>
          <p>
            Rejoignez une communauté dynamique d'étudiants burkinabés au Sénégal.
            Ensemble, nous cultivons l'excellence, l'entraide et nos valeurs culturelles.
          </p>
          <div className="hero-buttons">
            <button onClick={handleJoinClick} className="btn btn-primary">
              Nous rejoindre
            </button>
            <a href="/a-propos" className="btn btn-secondary">
              En savoir plus
            </a>
          </div>

          <div className="carousel-indicators">
            {carouselImages.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
                aria-label={`Afficher l’image ${index + 1} : ${carouselImages[index].alt}`}
                aria-current={index === currentImageIndex ? 'true' : undefined}
              />
            ))}
          </div>
        </div>

        <div className="scroll-indicator">
          <div className="scroll-arrow"></div>
        </div>
      </section>

      {/* Section Statistiques */}
      <section className="stats-section" data-animate id="stats">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section À Propos de l'ASB - NOUVEAU */}
      <section className="about-asb-section" data-animate id="about-asb">
        <div className="about-asb-container">
          <div className="about-asb-content">
            <span className="about-asb-badge">Qui sommes-nous</span>
         
            <p>
              Une communauté unie au service de l'excellence et de la solidarité.
            </p>
            <p>
              Depuis plus de 65 ans, l'ASB accompagne les étudiants burkinabés au Sénégal
              dans leur parcours académique et personnel. Nous créons des liens,
              partageons nos cultures et construisons ensemble un avenir meilleur.
            </p>
            <p>
              Notre mission est de promouvoir l'entraide, l'excellence académique et
              le rayonnement de la culture burkinabè tout en facilitant l'intégration
              de nos membres dans leur environnement d'études.
            </p>

          </div>

          <div className="about-asb-image-wrapper">
            <div className="about-image-decoration"></div>
            <div className="about-image-decoration-2"></div>
            <div className="about-asb-image-container">
              <img
                src="/images/bureau/president.jpg"
                alt="Présidente de l'ASB"
                className="about-asb-image"
              />
              <div className="president-badge">
                <h4>Notre Présidente</h4>
                <p>Présidente ASB 2025-2027</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section À la une */}
      <section className="highlights" data-animate id="highlights">
        <div className="container">
          <div className="highlight-cards">
            {highlightCards.map((card, index) => (
              <div key={card.id} className={`card card-${card.color}`}>
                <div className="card-icon">{card.icon}</div>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                <a href={card.link} className="card-link">
                  En savoir plus
                  <span className="arrow">→</span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;